__turbopack_context__.v({
  "avatar": "ProfileTabUserList-module__g17QAW__avatar",
  "avatarImg": "ProfileTabUserList-module__g17QAW__avatarImg",
  "avatarInitials": "ProfileTabUserList-module__g17QAW__avatarInitials",
  "contactIcon": "ProfileTabUserList-module__g17QAW__contactIcon",
  "contactLink": "ProfileTabUserList-module__g17QAW__contactLink",
  "muted": "ProfileTabUserList-module__g17QAW__muted",
  "pageButton": "ProfileTabUserList-module__g17QAW__pageButton",
  "pageInfo": "ProfileTabUserList-module__g17QAW__pageInfo",
  "pagination": "ProfileTabUserList-module__g17QAW__pagination",
  "root": "ProfileTabUserList-module__g17QAW__root",
  "search": "ProfileTabUserList-module__g17QAW__search",
  "searchIcon": "ProfileTabUserList-module__g17QAW__searchIcon",
  "searchWrap": "ProfileTabUserList-module__g17QAW__searchWrap",
  "sendButton": "ProfileTabUserList-module__g17QAW__sendButton",
  "sendButtonDisabled": "ProfileTabUserList-module__g17QAW__sendButtonDisabled",
  "sendIcon": "ProfileTabUserList-module__g17QAW__sendIcon",
  "sendUnavailable": "ProfileTabUserList-module__g17QAW__sendUnavailable",
  "sortIcon": "ProfileTabUserList-module__g17QAW__sortIcon",
  "sortIconActive": "ProfileTabUserList-module__g17QAW__sortIconActive",
  "table": "ProfileTabUserList-module__g17QAW__table",
  "tableWrap": "ProfileTabUserList-module__g17QAW__tableWrap",
  "thInner": "ProfileTabUserList-module__g17QAW__thInner",
  "thSortable": "ProfileTabUserList-module__g17QAW__thSortable",
  "toolbar": "ProfileTabUserList-module__g17QAW__toolbar",
  "truncatedHint": "ProfileTabUserList-module__g17QAW__truncatedHint",
  "userCell": "ProfileTabUserList-module__g17QAW__userCell",
  "userName": "ProfileTabUserList-module__g17QAW__userName",
});
